export interface AdImageProperties {
    quality: number;
    sizes: string;
}

export type ListViewType = 'list' | 'grid' | 'gallery';

const BuildDefaultAdImageProperties = (viewType: ListViewType) => {
    return {
        quality: 50,
        sizes: viewType === 'list' ? '150px' : '50vw'
    };
};

export const getResponsiveImageAttributes = (
    imageLink: string,
    viewType: ListViewType,
    imageProperties = BuildDefaultAdImageProperties(viewType)
) => {
    const { quality, sizes } = imageProperties;

    const [urlLink] = (imageLink || '').split(';');
    const [_, rotation] = (imageLink || '').split('r=');
    const rotatedLink = `${urlLink}${rotation ? `;r=${rotation}` : ''}`;

    const src = `${rotatedLink};s=200x0;q=${quality}`;
    const srcSet = `${rotatedLink};s=100x0;q=${quality} 100w,
        ${rotatedLink};s=200x0;q=${quality} 200w,
        ${rotatedLink};s=300x0;q=${quality} 300w,
        ${rotatedLink};s=400x0;q=${quality} 400w,
        ${rotatedLink};s=600x0;q=${quality} 600w`;

    return [src, srcSet, sizes];
};
